import { render } from "./CustomizationShareEmailBody.vue?vue&type=template&id=b4757e98"
import script from "./CustomizationShareEmailBody.vue?vue&type=script&lang=js"
export * from "./CustomizationShareEmailBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__